import { SearchTabAiSearch as SearchTabAiSearchComponent } from './SearchTabAiSearch';

export const SearchTabAiSearch = SearchTabAiSearchComponent;
